import { useEffect, useState } from 'react';

/**
 * Sticky "has this ever fired" latch: flips to true the first time `value`
 * is true and then stays true, even after `value` goes back to false.
 *
 * Built for gating the mount of a lazy-loaded, one-shot effect component on
 * its own "*Active" flag — mounting only after the first trigger defers the
 * chunk fetch until it's actually needed, and staying mounted afterward
 * (rather than toggling with `value`) lets the component run its own
 * exit/cleanup sequence and call onComplete instead of being yanked out
 * from under itself.
 */
export function useLatch(value: boolean): boolean {
  const [latched, setLatched] = useState(false);
  useEffect(() => {
    if (value) setLatched(true);
  }, [value]);
  return latched;
}
